<template>
  <div class="userNavDropdown">
    <!-- <div class="userNavDropdown--profile">
      <ik-image loading="lazy" :transformation="[{ height: 60, width: 60 }]" :src="user.profileImageUrl ? user.profileImageUrl : replacementProfileImage" class="userNavDropdown--profile--image" />
      <div class="userNavDropdown--profile--name">{{ user.displayName }}</div>
    </div> -->
    <div class="userNavDropdown--subscriptionInfo">
      <!-- If user is premium -->
      <div class="userNavDropdown--subscriptionInfo--premium" v-if="user.isUserPremium">Premium Plan</div>
      <!-- If user is not premium -->
      <div v-else>
        <div class="userNavDropdown--subscriptionInfo--plan">Free plan</div>

        <div class="profileHeaderExperienceBar">
          <div class="profileHeaderExperienceBarProgress">{{ nrOfUsedFreeSessions }}/{{ MAX_FREE_SESSIONS_WEEK }} weekly free sessions</div>
          <div class="profileHeaderExperienceBarContainer">
            <div class="profileHeaderExperienceBarBase">
              <div class="profileHeaderExperienceBarFill" :style="{ width: getFreeSessionsProgressBarPercentage + '%' }"></div>
            </div>
            <div class="profileHeaderXPText">2/5</div>
          </div>
        </div>

        <!-- Show number of free sessions left for this week -->
        <div class="userNavDropdown--subscriptionInfo--details">
          <span class="userNavDropdown--subscriptionInfo--details--count">{{ nrOfUsedFreeSessions }}/{{ MAX_FREE_SESSIONS_WEEK }}</span> free sessions
          used this week.
        </div>

        <!-- Show button to Upgrade -->
        <div class="userNavDropdown--subscriptionInfo--upgrade" @click="openSubscriptionModal('Nav')">Upgrade</div>

       <!--  <a
          class="userNavDropdown--subscriptionInfo--details--more"
          href="https://www.cofocus.one/communities/cofocus/posts/62db92ad9460e1001657b917"
          target="_blank"
        >
          Learn more
        </a> -->
      </div>
    </div>
    <a :href="`/profile/${user._id}`" class="userNavDropdown-item"><div>My profile</div></a>
    <!-- <a :href="`/journal`" class="userNavDropdown-item"><div>Journal (beta)</div></a> -->
    <a @click="openSettingsModal" class="userNavDropdown-item"><div>Account settings</div></a>
    <a :href="`/affiliate-program`" class="userNavDropdown-item"><div>Affiliate Program 💰</div></a>
    <a :href="`/lordofthemedals`" class="userNavDropdown-item" v-if="isNick"><div>The Throne 👑</div></a>
    <a :href="`/admin/dashboard`" class="userNavDropdown-item" v-if="isAdmin"><div>Admin dashboard</div></a>
    <!-- <a href="/dashboard/changelog" class="dropdown-item">
      <div>🚀 What's New</div>
    </a> -->
    <!-- <a href="/dashboard/announcements" class="dropdown-item">
      <div>📢 Announcements</div>
    </a> -->
    <div class="userNavDropdown-item logout">
      <div @click="logUserOut" class="logout-button">Logout</div>
    </div>
  </div>
</template>

<!-- When user does have rooms, there can be a quick entry by displaying some of the rooms as some sort of circles on a separate row, which have an image or letter & it is scrollable, maybe expandable, it is still under 'My rooms' title.-->

<script>
import { mapState } from "vuex";
import auth from "@/api/auth";
import SettingsMethods from "../../../ELYX/Settings/SettingsMethods";
import SubscriptionMethods from "../../../ELYX/Subscriptions/SubscriptionMethods";
/* import SessionMethods from "../../../ELYX/Sessions/SessionMethods"; */
import { CalendarStore } from "../../../ELYX/ELYXStore";
import { SharedSessionConstants } from "@shared";

export default {
  name: "UserNav",
  computed: {
    nrOfUsedFreeSessions: () => CalendarStore.state.nrOfUsedFreeSessions,

    ...mapState({
      user: (state) => state.auth.user,
    }),

    isAdmin() {
      const admins = ["5ffa95888d24191c09f7f0bb", "609e51f7a601860015b41871", "60c559f4c0f06216f42042bc"];
      return admins.includes(this.user._id);
    },

    isNick() {
      return this.user._id === "60e9bb09b27e5d0015d73a2f";
    },

    getFreeSessionsProgressBarPercentage() {
      return (this.nrOfUsedFreeSessions / this.MAX_FREE_SESSIONS_WEEK) * 100;
    },
  },
  data() {
    return {
      MAX_FREE_SESSIONS_WEEK: SharedSessionConstants.MAX_FREE_SESSIONS_WEEK,
    };
  },
  /* async created() {
    await SessionMethods.getNrOfSessionsUserDidThisWeek();
  }, */
  methods: {
    openSettingsModal() {
      SettingsMethods.openSettingsModal();
    },
    openSubscriptionModal: SubscriptionMethods.openSubscriptionModal,
    async logUserOut() {
      try {
        const response = await auth.logout();
        if (response.data.success && this.$route.path !== "/") {
          /* this.$router.push("/"); */
          window.location.reload();
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.userNavDropdown {
  position: absolute;
  width: 200px;
  top: 43px;
  border-radius: 16px;
  transition: 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  padding: 0px 5px;
  padding-top: 12px;
  padding-top: 5px;
  cursor: default;
  padding-bottom: 4px;
  box-sizing: border-box;
  right: -15px;
  right: -8px;
  z-index: 10000;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(1px);
  backdrop-filter: blur(1px);
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
}
.userNavDropdown--profile {
  display: flex;
  align-items: center;
  padding: 10px 10px;
  border-radius: 16px;
  /* border-radius: 12px; */
  margin-bottom: 5px;
  background-color: #f5f5f5;
}
.userNavDropdown--profile--image {
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  border-radius: 360px;
  padding: 0px;
  box-sizing: border-box;
  width: 28px;
  height: 28px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
}
.userNavDropdown--profile--name {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
}
.userNavDropdown--subscriptionInfo {
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 16px;
  margin-bottom: 5px;
}
.userNavDropdown--subscriptionInfo--premium {
  color: #555555;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}
.userNavDropdown--subscriptionInfo--plan {
  color: #333;
  font-size: 16px;
  margin-bottom: 5px;
  font-weight: 600;
}
.userNavDropdown--subscriptionInfo--details {
  font-size: 13px;
  line-height: 16px;
  color: #555;
  text-align: center;
  display: none;
  margin-top: 5px;
}
.userNavDropdown--subscriptionInfo--details--count {
  font-weight: 500;
  color: #333;
}
.userNavDropdown--subscriptionInfo--details--more {
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  font-size: 13px;
  margin-left: auto;
  display: block;
  text-align: center;
  margin-top: 8px;
  color: #666;
}
.userNavDropdown--subscriptionInfo--details--more:hover {
  color: #888;
}
.userNavDropdown--subscriptionInfo--upgrade {
  background-color: #333;
  color: white;
  padding: 6px 12px;
  border-radius: 360px;
  text-align: center;
  font-size: 14px;
  margin-top: 8px;
  cursor: pointer;
}
.userNavDropdown--subscriptionInfo--upgrade:hover {
  background-color: #444;
}

.userNavDropdown-item {
  margin: 0px auto;
  background-color: transparent;
  padding: 8px 15px;
  font-size: 15px;
  cursor: pointer;
  box-sizing: border-box;
  margin-bottom: 5px;
  border-radius: 8px;
  font-weight: 600;
  color: #323333;
  width: 100%;
}

.userNavDropdown-item:hover {
  color: #777;
  background-color: #f5f5f5;
}

.userNavDropdown-active {
  background-color: #f3f4f7eb;
  /* border: 1px solid #eee; */
  color: #3e3a54;
}

.userNavDropdown-icon {
  position: absolute;
  height: 17px;
  width: 19px;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 11px;
  border: none !important;
  background-color: unset !important;
}

.logout {
  margin: 0 auto;
  width: 100%;
  background-color: unset;
  padding: 8px 14px;
  border-radius: 3px;
  cursor: default !important;
  margin-top: 5px;
  border: unset;
}

.logout:hover {
  background-color: unset;
  transform: scale(1);
  box-shadow: unset;
}

.logout-button {
  cursor: pointer;
  font-size: 14px;
  height: max-content;
  width: max-content;
  color: #9ca0a9;
}

.logout-button:hover {
  color: unset;
}

.profileHeaderExperienceBar {
  /*   padding: 15px;
  margin-left: 5px; */
}
.profileHeaderExperienceBarProgress {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 5px;
  margin-top: 5px;
}
.profileHeaderXPText {
  font-size: 14px;
  font-weight: 600;
}
.profileHeaderExperienceBarContainer {
  display: flex;
  align-items: center;
}
.profileHeaderExperienceBarBase {
  width: 250px;
  height: 14px;
  margin: 0px;
  border-radius: 12px;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  background: rgb(228 228 228 / 93%);
  box-sizing: border-box;
  padding: 1px 0px;
}
.profileHeaderExperienceBarFill {
  width: 0%;
  height: 12px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  box-sizing: border-box;
  margin-left: 1px;
}
.profileHeaderXPText {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  display: none;
  margin-left: 8px;
}
</style>
